import { AbstractFilterBuilder } from "./AbstractFilterBuilder";

export class CategoryFilterBuilder extends AbstractFilterBuilder {
    public build(value: string): string {
        return `["category","=","${value}"]`
    }
} 